export const mainCountries = {
    "France": "France",
    "Germany": "Germany",
    "India": "India",
    "United Kingdom": "United Kingdom",
    "United States": "United States"
};